import { heroStats, tickerItems } from '@/mocks/home';

export default function HeroSection() {
  const jump = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="hero" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20artistic%20watermelon%20watercolor%20composition%20with%20deep%20green%20rind%20and%20warm%20red%20tones%20on%20textured%20cream%20paper%2C%20editorial%20poster%20art%2C%20bold%20organic%20shapes%2C%20high%20contrast%2C%20dramatic%20dark%20shadows%20for%20text%20readability&width=1800&height=1100&seq=chigua-hero-2026&orientation=landscape"
          alt="51.吃瓜 吃瓜补课专区 首屏视觉"
          title="51.吃瓜 - 吃瓜前情回顾与事件全貌补课"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-foreground-950/85 via-foreground-950/65 to-primary-950/70" />
      </div>

      <div className="relative mx-auto flex min-h-[640px] w-full max-w-content flex-col justify-center px-4 pb-16 pt-28 md:min-h-[720px] md:px-6 md:pt-36">
        <div className="w-full max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 font-label text-xs tracking-wide text-background-50 backdrop-blur-sm">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-megaphone-line" />
            </span>
            事件补课专区 · 持续更新
          </span>

          <h1 className="mt-5 font-heading text-3xl font-black leading-tight tracking-tight text-background-50 sm:text-4xl md:text-6xl">
            吃瓜吃到一半没跟上？
            <span className="mt-2 block text-accent-300">来这儿补课就够了</span>
          </h1>

          <p className="mt-5 max-w-2xl font-body text-base leading-relaxed text-background-100/90 md:text-lg">
            51.吃瓜把每件事的<strong className="font-semibold text-background-50">前情回顾</strong>、<strong className="font-semibold text-background-50">事件全貌</strong>、背景资料、反转记录和后续进度整理成一条完整路径。不用翻几十条碎片消息，在这里一次补全来龙去脉。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#recap"
              onClick={(e) => {
                e.preventDefault();
                jump('recap');
              }}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-book-marked-line" />
              </span>
              开始补课
            </a>
            <a
              href="#timeline"
              onClick={(e) => {
                e.preventDefault();
                jump('timeline');
              }}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 bg-background-50/10 px-6 py-3.5 font-label text-sm font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 cursor-pointer"
            >
              查看事件全貌
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-down-line" />
              </span>
            </a>
          </div>
        </div>

        <dl className="mt-12 grid w-full grid-cols-2 gap-3 md:mt-16 md:grid-cols-4 md:gap-4">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-50/15 bg-background-50/10 px-4 py-4 backdrop-blur-sm md:px-5 md:py-5"
            >
              <dt className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {stat.value}
              </dt>
              <dd className="mt-1 font-label text-xs text-background-100/80 md:text-sm">
                {stat.label}
              </dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="relative border-t border-background-50/15 bg-foreground-950/60 py-3 backdrop-blur-sm">
        <div className="flex w-max marquee-track">
          {[0, 1].map((dup) => (
            <ul key={dup} className="flex items-center" aria-hidden={dup === 1}>
              {tickerItems.map((item) => (
                <li
                  key={`${dup}-${item}`}
                  className="flex items-center gap-2 px-5 font-label text-xs text-background-100/85 md:text-sm"
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
                  {item}
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </section>
  );
}